import React from "react";
import {
  Palette,
  Bell,
  Shield,
  FileText,
  Moon,
  ChevronRight,
} from "lucide-react";

const settings = [
  {
    icon: <Palette size={22} className="text-[#251A72]" />,
    title: "Appearance",
    subtitle: "Theme and Accent Color",
    right: (
      <>
        <div className="hidden sm:flex items-center gap-2 px-3 py-1 rounded-full bg-[#FFF7E7] border">
          <Moon size={14} className="text-[#F59E0B]" />
          <span className="text-xs font-medium text-gray-600">Dark Mode</span>
        </div>

        <div className="sm:hidden">
          <Moon size={18} className="text-[#F59E0B]" />
        </div>
      </>
    ),
  },
  {
    icon: <Bell size={22} className="text-[#251A72]" />,
    title: "Notifications",
    subtitle: "Email, SMS and push alerts",
  },
  {
    icon: <Shield size={22} className="text-[#251A72]" />,
    title: "Privacy",
    subtitle: "Control what we track and share",
  },
  {
    icon: <FileText size={22} className="text-[#251A72]" />,
    title: "Terms & Conditions",
    subtitle: "Control what we track and share",
  },
];

export default function Settings() {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 h-[calc(100vh-120px)] flex flex-col overflow-hidden">
      {/* Heading */}
      <div className="shrink-0 border-b border-gray-100 bg-white px-4 py-5 sm:px-6">
        <h2 className="text-2xl sm:text-[28px] font-semibold text-gray-800">
          Settings
        </h2>
      </div>

    {/* Scrollable Content */}
<div className="flex-1 overflow-y-auto hide-scrollbar px-4 py-5 sm:px-6">
  {/* Cards */}
  <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {settings.map((item, index) => (
          <button
            key={index}
            className="border border-gray-200 rounded-2xl p-4 sm:p-5 hover:shadow-md transition-all text-left"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 sm:gap-4 flex-1 min-w-0">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-[#F4F3FF] flex items-center justify-center flex-shrink-0">
                  {item.icon}
                </div>

                <div>
                  <h3 className="font-semibold text-base sm:text-lg text-gray-800">
                    {item.title}
                  </h3>

                  <p className="text-xs sm:text-sm text-[#8DA2C2] mt-1 break-words">
                    {item.subtitle}
                  </p>
                </div>
              </div>

              {item.right ? (
                item.right
              ) : (
                <ChevronRight size={20} className="text-gray-400" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
    </div>
  );
}
